import React from "react";
import img from "../../Assets/Blog Details/BlogImage.png";

const BlogImage = () => {
  return (
    <>
      <div className="py-6 px-4 md:px-10 ">
        <img
          src={img}
          alt=""
          className="w-full h-auto md:w-full md:h-auto xl:w-[872px] xl:h-[600px] rounded-lg"
        />
      </div>
    </>
  );
};

export default BlogImage;
